import React from 'react';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import { motion } from 'framer-motion';

const SocialButton = ({ href, icon: Icon, label }) => (
  <motion.a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="group relative p-3 rounded-lg overflow-hidden transition-transform hover:-translate-y-0.5"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
  >
    {/* Gradient background */}
    <div className="absolute inset-0 bg-gradient-to-tr from-white/10 to-white/5 group-hover:from-white/20 group-hover:to-white/10 transition-colors duration-300" />
    
    {/* Glow effect */}
    <div className="absolute inset-0 bg-white/5 blur group-hover:bg-white/10 transition-colors duration-300" />
    
    {/* Icon */}
    <div className="relative">
      <Icon className="w-8 h-8 transition-transform duration-300 group-hover:scale-110" />
    </div>
    
    {/* Accessible label */}
    <span className="sr-only">{label}</span>
  </motion.a>
);

export default function SocialMedia() {
  return (
    <div className="relative">
      <h3 className="text-lg font-semibold mb-4">Følg Os</h3>
      <div className="flex gap-4">
        <SocialButton
          href="https://www.facebook.com/BennysPolsevogn/?locale=da_DK"
          icon={FaFacebook}
          label="Følg os på Facebook"
        />
        <SocialButton
          href="https://www.instagram.com/explore/locations/1091843774194950/bennys-plsevogn/"
          icon={FaInstagram}
          label="Følg os på Instagram"
        />
      </div>

      {/* Whimsical Image */}
      <div className="absolute bottom-0 right-0 w-48 h-48 pointer-events-none">
        <img
          src="https://i.postimg.cc/Qxy7V0Q3/decorative-webp.webp"
          alt=""
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
}